import { Component, OnInit } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../../admin.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService } from '@shared/services/user.service';
import { SnackService } from '@shared/services/snack.service';
import { ICreateUser, ISCDUserDto } from '@shared/interfaces';
import { DialogService, GuardService } from '@shared/services';
import { UserRole } from '@shared/enums/UserRole';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-users-create',
    templateUrl: './admin-users-create.component.html',
    styleUrls: ['./admin-users-create.component.scss'],
    standalone: false
})
export class AdminUsersCreateComponent extends AdminActionsDirective implements OnInit {
    formGroup: UntypedFormGroup;
    roleTypes: UserRole[] = [UserRole.standard, UserRole.admin];

    constructor(
        private fb: UntypedFormBuilder,
        private userService: UserService,
        private snack: SnackService,
        private guardService: GuardService,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
    }

    ngOnInit(): void {
        this.buildForm();
    }

    get user(): ISCDUserDto {
        return this.formGroup.value.userData;
    }

    get isMaster(): boolean {
        return this.guardService.currentUser && this.guardService.currentUser.mainUser.id === 'Z003X1DP';
    }

    async saveUser(event: any): Promise<void> {
        this.disableSubmitter(event);

        if (this.formGroup.valid) {
            try {
                const result = await this.userService.createUser(await this.buildItem());
                this.snack.openSnackBarSuccess(`User ${result.userData.fullName} created successfully.`);
                this.goToMainView();
            } catch (e) {
                this.snack.openSnackBarError(e.error.message);
            }
        } else {
            this.snack.openSnackBarError('Please check your input.');
        }
        this.enableSubmitter(event);
    }

    private buildForm() {
        this.formGroup = this.fb.group({
            userData: [null, Validators.required],
            userRole: 'standard',
            certificate: []
        });
    }

    private buildItem(): Promise<ICreateUser> {
        return new Promise<ICreateUser>(resolve => {
            const item: ICreateUser = this.formGroup.getRawValue();
            if (item.certificate) {
                const reader = new FileReader();
                reader.readAsBinaryString(item.certificate[0] as File);
                reader.onload = () => {
                    item.certificate = reader.result;
                    resolve(item);
                };
            } else {
                resolve(item);
            }
        });
    }
}
